import { Grid } from '@material-ui/core'

import { Container, Page } from 'components'

import {
  ProductDetails,
  SellerDetails,
  BilletInfo,
  PaymentHeader,
} from './components'

import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

import { reverse } from 'named-urls'
import { routes } from 'Routes'
import { useState, useEffect } from 'react'
import * as service from 'service'

const BilletPayment = ({ match }) => {
  const type = match.params.type
  const token = match.params.token
  const location = useLocation()
  const history = useHistory()
  const customer = location.state?.customer
  const billet = location.state?.billet

  const [order, setOrder] = useState()

  if (customer == null) {
    history.push(
      reverse(routes.payments.main, {
        type: type,
        token: token,
      }),
    )
  }

  useEffect(() => {
    const loadOrder = async () => {
      const response = await service.intermediador.payments.show(type, token)
      setOrder(response?.data)
    }
    loadOrder()
    //eslint-disable-next-line
  }, [])

  return (
    <Page title="Pagar" paddingTop={0}>
      <PaymentHeader customer={customer} />
      <Container
        maxWidth={false}
        spacingXl={50}
        spacingLg={50}
        spacingMd={10}
        spacingSm={10}
      >
        <Grid container spacing={3}>
          <Grid item sm={4}>
            <ProductDetails order={order?.payment} />
          </Grid>
          <Grid item sm={8}>
            <BilletInfo billet={billet} />
          </Grid>
        </Grid>
        <SellerDetails seller={order?.seller} />
      </Container>
    </Page>
  )
}

export default BilletPayment
